import moment from 'moment';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { AmountField, Card, Space, StatusField, TextField } from '~/components';
import GridLayout from '~/layout/GridLayout';
import { Payroll } from '~/types';
import Cell from '~/pages/payrolls/components/Cell';

interface Props {
  record: Payroll;
  onClick?: () => void;
}

const PayrollCard: FC<Props> = (props) => {
  const { record, onClick } = props;
  const { t } = useTranslation('payrolls');

  return (
    <Card
      title={
        <GridLayout xs={12}>
          <TextField label={t('Instructed amount')}>
            <AmountField amount={record.instructedAmount} />
          </TextField>
          <StatusField data={record.status} />
        </GridLayout>
      }
      status={record.status}
      onClick={onClick}
      expandable
    >
      <Space size={16} direction="vertical">
        <TextField label={t('Posted amount')}>
          <AmountField amount={record.postedAmount} />
        </TextField>
        {record.description && <TextField label={t('Description')}>{record.description}</TextField>}
        <TextField label={t('Number of records')}>{record.recordsTotal}</TextField>
        <TextField label={t('Executed by')}>
          <Cell.Employee record={record} />
        </TextField>
        <TextField label={t('Date')}>{moment(record.createdAt).format('LL LT')}</TextField>
      </Space>
    </Card>
  );
};

export default PayrollCard;
